import React, { useEffect, useState } from 'react';
import GuacConnect from './GuacConnect';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const GuacamolePage = () => {
    const [guacData, setGuacData] = useState(null);
    const [refreshConnection, setRefreshConnection] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [instancelist, setinstancelist] = useState([]);

    useEffect(() => {
        const data = localStorage.getItem('guacData');
        if (data) {
            const parsedData = JSON.parse(data);
            setGuacData(parsedData);
        }
    }, []);

    useEffect(() => {
        const InstanceID = localStorage.getItem("InstanceID");
        console.log('InstanceID', InstanceID);
        fetch(`${process.env.REACT_APP_API_URL}/api/labcustomize/${InstanceID}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                    // Handle case where there is a detail
                } else {
                    setinstancelist(data);
    
                    // Filter instance from instancelist where the name matches guacData.name
                    const instanceInfo = data[0].Instance_info || [];
                    console.log("instanceInfo",instanceInfo);
                    const instance = instanceInfo[0].details.find(detail => detail.name === guacData.name);

                    console.log("instance",instance);
    
                    if (instance) {
                        const status = instance.status;
                        if (status !== 'running') {
                            setOpenDialog(true);
                        }
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [guacData, refreshConnection]);

    console.log("setOpenDialog", openDialog);

    console.log("instancelist", instancelist);

    const handleRefreshConnection = () => {
        setRefreshConnection(true);
    };

    const handleCloseDialog = () => {
        window.close();
    };

    if (!guacData) {
        return <div>Loading...</div>;
    }

    return (
        <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <header style={{ padding: '10px', backgroundColor: '#f5f5f5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Guacamole Display - Machine Name: {guacData.name}</h2>
                <div>
                    <button onClick={handleRefreshConnection} style={{ marginRight: '10px', color: 'blue' }}>Refresh</button>
                    <button onClick={() => window.close()} style={{ color: 'red' }}>Close</button>
                </div>
            </header>
            <main style={{ flexGrow: 1, overflow: 'auto' }}>
                <GuacConnect
                    details={guacData}
                    refreshConnection={refreshConnection}
                    instanceStatus={guacData.status}
                    disableCopyPaste={guacData.disable_copypaste_guac}
                    onRefreshComplete={() => setRefreshConnection(false)}
                />
            </main>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Instance Status"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please check the instance status.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default GuacamolePage;
